export default __webpack_public_path__ + "static/media/ra-play.ad6c9515.svg";